import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Message } from '../../../subcomponents/message/message';
export var ShowtimeSeatPreviewMessageType;
(function (ShowtimeSeatPreviewMessageType) {
    ShowtimeSeatPreviewMessageType["FailedToLoadData"] = "FailedToLoadData";
    ShowtimeSeatPreviewMessageType["SoldOut"] = "SoldOut";
})(ShowtimeSeatPreviewMessageType || (ShowtimeSeatPreviewMessageType = {}));
const b = bemClassBuilder('v-showtime-seat-preview-message');
export const ShowtimeSeatPreviewMessage = observer(props => {
    const { type, displayText, assets } = props;
    return _jsx(Message, Object.assign({}, getMessageProps(type, displayText, assets), { className: b.block() }));
});
ShowtimeSeatPreviewMessage.displayName = 'ShowtimeSeatPreviewMessage';
export const getMessageProps = (type, displayText, assets) => {
    switch (type) {
        case ShowtimeSeatPreviewMessageType.FailedToLoadData:
            return {
                iconName: assets.failedToLoadDataIconName,
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage
            };
        case ShowtimeSeatPreviewMessageType.SoldOut:
            return {
                iconName: assets.soldOutIconName,
                title: displayText.soldOutTitle,
                description: displayText.soldOutMessage
            };
        default:
            throw new Error(`Cannot get message props for unknown ShowtimeSeatPreviewMessageType '${type}'.`);
    }
};
//# sourceMappingURL=message.js.map